'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _VstComponent2 = require('./VstComponent');

var _VstComponent3 = _interopRequireDefault(_VstComponent2);

var _VstTabBar = require('./VstTabBar');

var _VstTabBar2 = _interopRequireDefault(_VstTabBar);

var _VstTabPanels = require('./VstTabPanels');

var _VstTabPanels2 = _interopRequireDefault(_VstTabPanels);

var _VstTab = require('./VstTab');

var _VstTab2 = _interopRequireDefault(_VstTab);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VstTabs = function (_VstComponent) {
  _inherits(VstTabs, _VstComponent);

  function VstTabs(props) {
    _classCallCheck(this, VstTabs);

    var _this = _possibleConstructorReturn(this, (VstTabs.__proto__ || Object.getPrototypeOf(VstTabs)).call(this, props));

    _this.state = {
      activeIndex: props.activeIndex
    };
    return _this;
  }

  _createClass(VstTabs, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var activeIndex = this.state.activeIndex;

      var children = _react2.default.Children.map(this.props.children, function (child) {
        if (child.type.displayName === "VstTabPanels") {
          return _react2.default.cloneElement(child, { activeIndex: activeIndex });
        } else if (child.type.displayName === "VstTabBar") {
          return _react2.default.cloneElement(child, {
            activeIndex: activeIndex,
            onClick: function onClick(activeIndex) {
              _this2.setState({ activeIndex: activeIndex });
            }
          });
        } else {
          return child;
        }
      });

      return _react2.default.createElement(
        'div',
        null,
        children
      );
    }
  }]);

  return VstTabs;
}(_VstComponent3.default);

exports.default = VstTabs;


VstTabs.defaultProps = {
  activeIndex: 0
};

VstTabs.Bar = _VstTabBar2.default;
VstTabs.Bar.displayName = "VstTabBar";
VstTabs.Panels = _VstTabPanels2.default;
VstTabs.Panels.displayName = "VstTabPanels";
VstTabs.Tab = _VstTab2.default;


/** WEBPACK FOOTER **
 ** ./~/vstui/lib/components/VstTabs.js
 **/